module.exports = __webpack_public_path__ + "img/logo.0bbdf7e7.png";